import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { ApiService } from 'src/app/services/API/api.service';
import { CachingService } from 'src/app/services/cache/caching.service';
import { GlobalService } from 'src/app/services/global/global.service';
import { WidgetsService } from 'src/app/services/ui/widgets.service';

@Component({
  selector: 'app-feedback',
  templateUrl: './feedback.component.html',
  styleUrls: ['./feedback.component.scss'],
})
export class FeedbackComponent implements OnInit {
  feedbackObj = [];
  currentIndex = 0;
  fetchingFeedbackDetails: boolean;
  selectedOption: any = {};
  selectedOptionLength: number = 0;
  comment: any;
  formSubmitOrSkipped: any;

  constructor(
    private modalController: ModalController,
    private apiService: ApiService,
    private globalService: GlobalService,
    private cachingService: CachingService,
    private widgetsService: WidgetsService
  ) {}

  ngOnInit() {
    this.cachingService.setDataInLocal('fb_shown', true);
    this.getFeedbackDetails();
    this.globalService.isFeedbackformOpen = true;
    this.apiService.logGAEvent(
      'uaevent',
      'Content',
      'Feedback_form_Summ',
      'Form_Open'
    );
  }

  getFeedbackDetails() {
    this.fetchingFeedbackDetails = true;
    const requestBody = {
      source: 'configurator',
      thumbs_down: false,
      thumbs_up: false,
    };
    this.apiService
      .post('feedback/create', requestBody)
      .then((res: any) => {
        if (res.statusCode === 201) {
          this.feedbackObj = res.response;
          this.fetchingFeedbackDetails = false;
        } else {
          console.log('error feching feednack form details');
          this.fetchingFeedbackDetails = false;
        }
      })
      .catch((err) => {
        this.fetchingFeedbackDetails = false;
        console.log(err);
      });
  }

  async nextSlide(thumb, feedback: any) {
    let thumbUp = thumb == 'up' ? true : false;
    this.apiService.logGAEvent(
      'uaevent',
      'Content',
      'Stage_' + (this.currentIndex + 1) + '_Summ',
      thumbUp ? 'Thumbs_Up' : 'Thumbs_Down'
    );

    this.selectedOption[feedback.question_id] = thumb;
    this.selectedOptionLength = Object.keys(this.selectedOption).length;
    this.currentIndex += 1;
    const config_id = await this.cachingService.getDataFromSession('c_id');
    const requestBody = {
      question_id: feedback.question_id,
      configuration_id: config_id,
      source: 'configurator',
      thumbs_up: thumbUp,
      thumbs_down: !thumbUp,
    };

    this.apiService.post('feedback/create', requestBody).then(() => {});
    // close thank you form automatically after 5secs
    // if (this.currentIndex == this.feedbackObj.length) {
    //   setTimeout(() => {
    //     this.close();
    //   }, 5000);
    // }
  }

  async submit() {
    this.widgetsService.showLoader();
    const config_id = await this.cachingService.getDataFromSession('c_id');
    const requestBody = {
      configuration_id: config_id,
      source: 'configurator',
      comments: this.comment,
    };
    this.apiService
      .post('feedback/create', requestBody)
      .then(() => {
        this.widgetsService.hideLoader();
        this.formSubmitOrSkipped = true;
        setTimeout(() => {
          this.close();
        }, 2000);
      })
      .catch((err) => {
        this.widgetsService.hideLoader();
        this.close();
      });
    // close thank you form automatically after 5secs
  }

  close() {
    this.globalService.isFeedbackformOpen = false;
    if (this.selectedOptionLength >= this.feedbackObj.length) {
      this.apiService.logGAEvent(
        'uaevent',
        'Content',
        'Stage_' + this.selectedOptionLength + '_Summ',
        'Feedback_Given'
      );
    } else {
      this.apiService.logGAEvent(
        'uaevent',
        'Content',
        'Stage_' + this.selectedOptionLength + '_Summ',
        'Form_Closed_' + this.selectedOptionLength
      );
    }
    this.globalService.dismissModal(true);
  }
}
